export const COMPANY = {
  name: "ARTISAN GUILD INFRA",
  tagline: "CARVING LANDMARKS",
  system: "YKK AP iWIN-S Aluminium Window & Door System",
  partner: "BHORUKA — A YKK AP COMPANY",
  email: "operations@artisanguildinfra.com",
  website: "https://artisanguildinfra.com",
  address_1: "Kovilpalayam, Coimbatore, Tamilnadu - 641107",
  address_2: "Malikadav Road, Kozhikode, Kerala - 673010",
  ceo_name: "JITHIN RAJ NK",
  ceo_title: "CEO",
  ceo_phone: "+91-8754505413",
  gst_percent: 18,
};

export const LOGOS = {
  agi: "/agi-logo.png",
  bhoruka: "/bhoruka-logo.png",
  ykk: "/ykk-ap-logo.png",
};

export const OTP_EMAIL = "agiprojects24@gmail.com";
